const validate = values => {
	const errors = {}
	if (!values.state_id) {
		errors.state_id = 'Este Campo es Obligatorio'
	}
	if (!values.form_locality) {
		errors.form_locality = 'Este Campo es Obligatorio'
	}
	if (!values.zip_code) {
		errors.zip_code = 'Este Campo es Obligatorio'
	}
	if (!values.address_street) {
		errors.address_street = 'Este Campo es Obligatorio'
	}
	return errors
}

export default validate


/** WEBPACK FOOTER **
 ** ./src/components/Validations/submitValidationsAddressForm.js
 **/